import AndroidIcon from "@mui/icons-material/Android";
import AutoAwesomeIcon from "@mui/icons-material/AutoAwesome";
import BusinessIcon from "@mui/icons-material/Business";
import DatasetLinkedIcon from "@mui/icons-material/DatasetLinked";
import HelpIcon from "@mui/icons-material/Help";
import PersonIcon from "@mui/icons-material/Person";

export const DeviceIcon = AndroidIcon;
export const IntegrationIcon = DatasetLinkedIcon;
export const InvocationIcon = AutoAwesomeIcon;
export const OrgIcon = BusinessIcon;
export const UnknownIcon = HelpIcon;
export const UserIcon = PersonIcon;
